<template>
  <b-container>
    <b-row class="text-left">
      <b-col></b-col>
      <b-col cols="10" class="mb-3 mt-3">
        <h3>Evaluation Templates</h3>
      </b-col>
      <b-col></b-col>
    </b-row>
    <LoadingIndicator 
      v-if="loading"
      topic="Questions"
    />
    <div v-if="!loading">
      <b-row class="text-left">
        <b-col></b-col>
        <b-col cols="5" class="mb-3">
          <b-form-input type="text" placeholder="Enter search text" v-model="searchFilter"></b-form-input>
        </b-col>
        <b-col cols="5" class="mb-3 text-right">
          <b-button id="addNew" variant="success" @click.stop="createQuestion()">Create New Question</b-button>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row class="text-left">
        <b-col></b-col>
        <b-col cols="10">
          <b-table
            v-if="questions.length"
            striped
            hover 
            responsive
            :items="questions"
            :fields="fields"
            :filter="searchFilter"
          >
            <template v-slot:cell(buttons)="data">
              <b-button-group>
                <b-button
                  size="sm"
                  variant="primary"
                  title="Edit Question"
                  v-b-tooltip.hover
                  @click.stop="editQuestion(data.item)">
                  <img src="/assets/edit-solid.svg" style="height: 20px;" />
                </b-button>
                <b-button
                  size="sm"
                  variant="danger"
                  type="button"
                  title="Delete Question"
                  v-b-tooltip.hover
                  @click.stop="confirmDelete(data.item)">
                  <img src="/assets/trash-alt-regular.svg" style="height: 20px;" />
              </b-button>
              </b-button-group>
              <!-- <b-button variant="primary" size="sm" @click.stop="editQuestion(data.item)">
                Edit
              </b-button> -->
            </template>
          </b-table>
          <BaseMessageBlock :messages="errors"></BaseMessageBlock>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <b-modal
      :ref="'delete-question-modal'"
      @ok.prevent="deleteQuestion(questionToDelete.id)"
      ok-variant="danger"
      :ok-disabled="sending"
      cancel-title="No!"
      cancel-variant="primary"
      centered
      title="Delete Confirmation"
    >
      <p>Are you sure you want to delete question: "{{questionToDelete.text}}"?</p>
      <BaseMessageBlock :messages="deleteErrors"></BaseMessageBlock>
      <template v-slot:modal-ok >
        <div style="width: 90px;" >
          <b-spinner v-if="sending" small label="Spinning"/>
          <div v-else>Yes, I'm sure.</div>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import axios from "axios";

export default {
  name: "QuestionList",
  data() {
    return {
      questions: [],
      errors: [],
      deleteErrors: [],
      searchFilter: null,
      loading: false,
      sending: false,
      questionToDelete: this.newQuestionToDelete(),
      fields: [
        { key: "buttons", label: "" },
        { key: "text", sortable: true }
      ]
    };
  },
  mounted() {
    if (!this.isSystemAdmin) {
      this.defaultRedirect();
    }
    this.loadQuestions();
  },
  methods: {
    loadQuestions() {
      this.loading = true;
      axios
        .get(`${this.$api_url}/question-templates?ao=false`, this.getReqConfig())
        .then(response => {
          this.questions = this.sortQuestions(response.data);
        })
        .catch(err => {
          this.errors.push(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sortQuestions(questions) {
      return questions.sort(function(a, b) {
        return a.text > b.text ? 1 : -1;
      });
    },
    createQuestion() {
      this.$router.push({
        name: "New Question Template"
      });
    },
    editQuestion(questionItem) {
      this.$router.push({
        name: "Edit Question Template",
        params: {
          id: questionItem.questionId
        }
      });
    },
    deleteQuestion(questionId) {
      // event.preventDefault();
      this.deleteErrors = [];
      this.sending = true;
      axios
        .delete(`${this.$api_url}/question-templates/${questionId}`, this.getReqConfig())
        .then(() => {
          this.$refs['delete-question-modal'].hide();
          this.questionToDelete = this.newQuestionToDelete();
          this.loadQuestions();
        })
        .catch(err => {
          this.deleteErrors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sending = false;
        });
    },
    confirmDelete(question) {
      this.questionToDelete.id = question.questionId;
      this.questionToDelete.text = question.text; 
      this.$refs['delete-question-modal'].show();
    },
    newQuestionToDelete() {
      return {
        id: '',
        text: ''
      }
    }
  }
};
</script>
